import React, { useEffect, useState } from "react";
 import { useParams } from "react-router-dom";
import StablePrime from "../../../Tables/StablePrime";


function ZenTable({ setPageHeader, urlData }) {
  setPageHeader();
  let { typ } = useParams();
  let { subtyp } = useParams();
  const [loading, setLoading] = useState(true);
  const [paramData, setParamsData] = useState();

  useEffect(() => {
    setLoading(true);
    if(urlData){
      setParamsData(urlData);
    } else {
      setParamsData({ typ: typ, subTyp: subtyp });
    };
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [typ, subtyp, urlData]);
  
  return !loading && (
    <div>
      {/* <StablePrime url="report/tom" data={{}} identity="perfparam" /> */}
      <StablePrime editSingleColumn={true} url="/zen/zentable"
        data={paramData}
        identity="" />
    </div>
  );
}

export default ZenTable;
